var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientMaintanance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.433.692A1.25 1.25 0 0125.55 0h2.5a1.25 1.25 0 011.116.692l1.667 3.333a1.25 1.25 0 01-.032 1.178L29.3 7.833v8.834h2.083a1.25 1.25 0 011.25 1.25v2.916H20.966v-2.916a1.25 1.25 0 011.25-1.25H24.3V7.833l-1.502-2.63a1.25 1.25 0 01-.033-1.178L24.433.692zm-3.467 22.641V27.5a5.833 5.833 0 0011.667 0v-4.167H20.966zM12.346.353A1.25 1.25 0 0113.51.227a9.17 9.17 0 01.85 16.66v12.22a4.227 4.227 0 01-8.454 0v-12.22a9.17 9.17 0 01.85-16.66 1.25 1.25 0 011.71 1.161V7.5a1.667 1.667 0 103.334 0V1.388a1.25 1.25 0 01.546-1.033",
    fill: "#DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.433.692A1.25 1.25 0 0125.55 0h2.5a1.25 1.25 0 011.116.692l1.667 3.333a1.25 1.25 0 01-.032 1.178L29.3 7.833v8.834h2.083a1.25 1.25 0 011.25 1.25v2.916H20.966v-2.916a1.25 1.25 0 011.25-1.25H24.3V7.833l-1.502-2.63a1.25 1.25 0 01-.033-1.178L24.433.692zm-3.467 22.641V27.5a5.833 5.833 0 0011.667 0v-4.167H20.966zM12.346.353A1.25 1.25 0 0113.51.227a9.17 9.17 0 01.85 16.66v12.22a4.227 4.227 0 01-8.454 0v-12.22a9.17 9.17 0 01.85-16.66 1.25 1.25 0 011.71 1.161V7.5a1.667 1.667 0 103.334 0V1.388a1.25 1.25 0 01.546-1.033",
    fill: "url(#paint0_linear_3833_2884)",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.433.692A1.25 1.25 0 0125.55 0h2.5a1.25 1.25 0 011.116.692l1.667 3.333a1.25 1.25 0 01-.032 1.178L29.3 7.833v8.834h2.083a1.25 1.25 0 011.25 1.25v2.916H20.966v-2.916a1.25 1.25 0 011.25-1.25H24.3V7.833l-1.502-2.63a1.25 1.25 0 01-.033-1.178L24.433.692zm-3.467 22.641V27.5a5.833 5.833 0 0011.667 0v-4.167H20.966zM12.346.353A1.25 1.25 0 0113.51.227a9.17 9.17 0 01.85 16.66v12.22a4.227 4.227 0 01-8.454 0v-12.22a9.17 9.17 0 01.85-16.66 1.25 1.25 0 011.71 1.161V7.5a1.667 1.667 0 103.334 0V1.388a1.25 1.25 0 01.546-1.033",
    fill: "url(#paint1_linear_3833_2884)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3833_2884",
    x1: -0.53,
    y1: 33.333,
    x2: 32.633,
    y2: 33.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#DD0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#7D0006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3833_2884",
    x1: -0.53,
    y1: 33.333,
    x2: 32.633,
    y2: 33.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientMaintanance);
export default __webpack_public_path__ + "static/media/gradient-maintanance.28aba6ce890886968fe3c8b1e535fe67.svg";
export { ForwardRef as ReactComponent };